import { useState } from "react";
import FormField from "../../../shared/components/FormField";
import { useAsync } from "../../../shared/hooks/useAsync";
import { authenticationApi } from "../api/authentication.api";
import { validators } from "../validation/authentication.validation";

/**
 * Password-reset request form: validates the email and asks the backend
 * to send a reset link, without revealing whether the account exists.
 */
export default function ForgotPasswordForm({ onBack }) {
    const [email, setEmail] = useState("");
    const [fieldError, setFieldError] = useState(null);
    const [sent, setSent] = useState(false);
    const { run, loading, error } = useAsync();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const err = validators.email(email);
        setFieldError(err);
        if (err) return;

        const data = await run(() => authenticationApi.forgotPassword(email));
        if (data) setSent(true);
    };

    if (sent) {
        return (
            <div className="ogm-auth-form">
                <p className="ogm-auth-success" style={{ textAlign: "left" }}>
                    If an account exists for <strong>{email}</strong>, we've sent a
                    password reset link — check your inbox.
                </p>
                <span className="ogm-back-link" onClick={onBack} role="button" tabIndex={0}>
                    ← Back to Login
                </span>
            </div>
        );
    }

    return (
        <form className="ogm-auth-form" onSubmit={handleSubmit} noValidate>
            <p className="ogm-otp-sent-to">
                Enter your account email and we'll send you a link to reset your password.
            </p>

            <FormField
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={fieldError}
                autoFocus
                required
            />

            {error && (
                <p className="ogm-auth-error" role="alert">
                    {error}
                </p>
            )}

            <button className="ogm-primary-btn" disabled={loading} type="submit">
                {loading ? "Sending…" : "Send reset link"}
            </button>

            <span className="ogm-back-link" onClick={onBack} role="button" tabIndex={0}>
                ← Back to Login
            </span>
        </form>
    );
}
